import { atomWithStorage } from "jotai/utils";

/**
 * Row/thumbnail size for product lists and the main product grid.
 * Shared across both surfaces so the toggle is consistent wherever it appears.
 */
export type ProductRowSize = "compact" | "large";

export const productRowSizeAtom = atomWithStorage<ProductRowSize>(
  "product_row_size",
  "large"
);

type RowMetrics = {
  rowHeight: number;
  thumbWidth: number;
  thumbHeight: number;
};

// Thumbnails come from the 150px server thumb (ImageManager.Thumb150), so
// anything up to 150 renders without extra bytes and without blur.

/** Product picker / selection lists (auto grid, price list, catalog create, ...). */
export const PRODUCT_LIST_METRICS: Record<
  ProductRowSize,
  RowMetrics & { columnWidth: number }
> = {
  compact: { rowHeight: 52, thumbWidth: 30, thumbHeight: 30, columnWidth: 60 },
  large: { rowHeight: 76, thumbWidth: 64, thumbHeight: 64, columnWidth: 84 },
};

/** Main product grid (Products page). */
export const PRODUCT_GRID_METRICS: Record<ProductRowSize, RowMetrics> = {
  compact: { rowHeight: 52, thumbWidth: 50, thumbHeight: 40 },
  large: { rowHeight: 76, thumbWidth: 80, thumbHeight: 64 },
};
